/* ── Shared state between the Voices scene and HexField ──
   The Voices scene writes the active testimonial index as you scroll; HexField
   reads it to swap the particle shape (quote → star → hexagon) for each voice. */
export const voicesStore = {
  /** Active testimonial index (0-based). */
  index: 0,
}
